import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";

export function FutureAppointmentsToggle({ showFutureAppointment }) {
  const dispatch = useDispatch();

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  const toggleFutureAppointment = useSelector(
    (state) => state.laser.selectedFilters.toggleFutureAppointment
  );

  const showAppointmentsToggle = showFutureAppointment && startFrom == "leads";

  const handleChangeFutureAppointment = (event) => {
    dispatch(actionCreators.toggleFutureAppointment(event.target.checked));
  };

  return showAppointmentsToggle ? (
    <div className="select-box toggle" style={{ width: 130 }}>
      <p className="offers-title">Future Bookings</p>
      <input
        type="checkbox"
        className="ios8-switch"
        id="future-toggle"
        checked={toggleFutureAppointment}
        onChange={handleChangeFutureAppointment}
      />
      <label htmlFor="future-toggle" />
    </div>
  ) : null;
}
